<template>
  <div class="assets">
    <div class="filter-wrapper">
      <div class="first-block">
        <search-input v-model="searchText" :placeholder="'Search'" />
        <div style="line-height: 42px;">
          My Collection:
        </div>
        <CustomDropdown
          v-if="collections.length > 0"
          v-model="params.collection_address"
          class="custom-dropdown"
          :display-list="collectionNames"
          :value-list="collectionAddresses"
        />
      </div>
      <!--      <div class="second-block">-->
      <!--        <SecondaryButton class="create-bundle-button" @onClick="openCreateBundle()">-->
      <!--          <img class="add-icon" src="@/assets/icon/rounded-plus.svg"/>-->
      <!--          Create Bundle-->
      <!--        </SecondaryButton>-->
      <!--      </div>-->
    </div>
    <template v-if="assets && assets.length">
      <div class="artwork-wrapper">
        <template v-for="asset in assets">
          <MyAssetsCard
            :key="asset.nftId"
            :image-url="asset.image"
            :nft-contract="asset.nftContract"
            :nft-id="asset.nftId"
            :nft-name="asset.name"
          />
        </template>
      </div>
      <!--    <CreateBundle v-if="currentDisplay === 'createBundle'" />-->
      <div class="market-pagination" v-if="totalPage > 1">
        <pagination
          ref="paginate"
          :page-count="totalPage"
          :page="page"
          @handlePageChange="handleChangePage"
        />
      </div>
    </template>
    <template v-else>
      <div class="blank-state">
        No items found
      </div>
    </template>
  </div>
</template>

<script>
import Pagination from '@/components/BaseComponents/CustomPagination.vue';
// import SearchInput from "@/components/BaseComponents/SearchInput.vue";
import CustomDropdown from '@/components/BaseComponents/CustomDropdown.vue';
// import SecondaryButton from "@/components/BaseComponents/SecondaryButton.vue";
import MyAssetsCard from '@/components/BaseComponents/MyAssetsCard.vue';
// import config from "@/config";
// import CreateBundle from '@/components/MyCollection/CreateBundle.vue';
import { mapState } from 'vuex';
import rf from '@/requests/RequestFactory';
import SearchInput from '@/components/BaseComponents/SearchInput';

const LIMIT_PER_PAGE = 12;
export default {
  components: {
    SearchInput,
    // SearchInput,
    CustomDropdown,
    Pagination,
    // SecondaryButton,
    MyAssetsCard
    // CreateBundle
  },
  data() {
    return {
      isInitializing: false,
      params: {
        collection_address: ''
      },
      assets: [],
      page: 1,
      totalPage: 1,
      searchText: '',
      collections: []
    };
  },
  computed: {
    ...mapState('auth', ['address']),
    myAddress() {
      return this.$store.state.auth.address;
    },
    myAccessToken() {
      return this.$store.state.auth.accessToken;
    },
    collectionNames() {
      if (!this.collections) {
        return [];
      }
      return this.collections.map(collection => {
        return collection.name;
      });
    },
    collectionAddresses() {
      if (!this.collections) {
        return [];
      }
      return this.collections.map(collection => {
        return collection.nftContract;
      });
    }
  },
  watch: {
    'params.collection_address': {
      handler() {
        if (!this.myAddress || this.isInitializing) {
          return;
        }
        this.page = 1;
        this.totalPage = 1;
        this.assets = [];
        this.fetchAssets();
      },
      deep: true
    },
    myAddress() {
      if (this.isInitializing) {
        return;
      }
      this.init();
    },
    myAccessToken() {
      this.fetchAssets();
    },
    searchText() {
      this.fetchAssets();
    }
  },
  mounted() {
    if (this.isInitializing) {
      return;
    }
    this.init();
  },
  methods: {
    handleChangePage(pageNum) {
      this.page = pageNum;
      this.fetchAssets();
    },
    async init() {
      this.isInitializing = true;
      await this.fetchCollections();
      this.setDefaultCollectionIfNeed();
      await this.fetchAssets();
      this.isInitializing = false;
    },
    setDefaultCollectionIfNeed() {
      if (!this.params.collection_address) {
        this.$set(
          this.params,
          'collection_address',
          this.collectionAddresses[0]
        );
      }
    },
    async fetchAssets() {
      if (!this.myAccessToken) {
        return;
      }
      const params = {
        page: this.page,
        limit: LIMIT_PER_PAGE,
        search: this.searchText,
        nftContract: this.params.collection_address
      };
      const res = await rf.getRequest('CollectionRequest').getAssets(params);
      this.assets = res.docs || [];
      this.page = res.page || 1;
      this.totalPage = res.totalPages || 1;
    },
    async fetchCollections() {
      const res = await rf.getRequest('CollectionRequest').getList();
      this.collections = res;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.market-pagination {
  margin-top: 45px;
  justify-content: center;
  display: flex;
}

.assets {
  .filter-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .first-block {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      div {
        margin: 10px;
      }
    }
    .second-block {
      .create-bundle-button {
        display: flex;
        justify-content: center;
        align-items: center;
        .add-icon {
          margin-right: 10px;
        }
        &:hover {
          .add-icon {
            filter: brightness(0) invert(1);
          }
        }
      }
    }
  }
  .artwork-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }
}

@media screen and (max-width: $breakpoint-mobile) {
  .assets {
    .filter-wrapper {
      flex-direction: column;
      .first-block {
        width: 100%;
        ::v-deep .input-search-wrapper {
          width: 100%;
          input {
            width: 100%;
          }
        }
        .dropdown-wrapper {
          width: 44%;
        }
      }
      .second-block {
        margin-top: 10px;
      }
    }
  }
  .artwork-wrapper {
    .artwork-card {
      margin: 10px;
    }
  }
}
.blank-state {
  text-align: center;
  font-size: 2rem;
  height: 250px;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 30px;
}
</style>
